import React from "react";

import styles from "./Burger.module.scss";

export default function Burger({opened}) {
    return (
        <span className={[styles.Main, opened ? 'opened' : ''].join(' ')}>
            <span/>
            <span/>
            <span/>
        </span>
    )
}
